import React from 'react';

export const CardLock = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1447_5378)">
      <g clipPath="url(#clip1_1447_5378)">
        <path
          d="M11 11.6667V9.66667C11 8.7462 11.7462 8 12.6667 8C13.5871 8 14.3333 8.7462 14.3333 9.66667V11.6667M10 11.6667H15.3333V15H10V11.6667Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path d="M7.99984 12.3333H0.666504V3H15.3332V7" stroke="currentColor" strokeWidth="1.5" />
        <path d="M6.6665 7.66669H9.33317" stroke="currentColor" />
        <path d="M2.6665 7.66669H5.33317" stroke="currentColor" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1447_5378">
        <rect width="16" height="16" fill="white" />
      </clipPath>
      <clipPath id="clip1_1447_5378">
        <rect width="16" height="16" fill="white" transform="translate(0 1)" />
      </clipPath>
    </defs>
  </svg>
);
